//Componentes generales
import React, { useContext, useEffect, useReducer } from "react";
import productsReducer from "./productsReducer";
import productsContext from "./productsContext";

//Socket
import { SocketContext } from "../socket/socket";

//Rutas de api
import { getAbmProduct, uploadAbmProduct } from "../../api/abmProduct.js"

//Acciones
import {
    ACTUALIZAR_PRODUCTOS,
    ACTUALIZAR_PRODUCTOS_DB,
    ACTUALIZAR_PRODUCTOS_SOCKET,
    CARGANDO_PROD,
    ERROR_PROD,
    LIMPIAR_ERROR
} from "./productsAction";

/*
    State encargado de la gestión de productos.
*/
const ProductsState = props => {

    const server = useContext(SocketContext);

    //Valores iniciales
    const initialState = {
        products: [],
        // Arranca en true: todavía no se hizo la carga inicial, evita mostrar
        // "No hay registros" antes de que llegue la respuesta del servidor.
        cargando: true,
        error: ""
    };

    const [state, dispatch] = useReducer(productsReducer, initialState);

    useEffect(() => {
        if (server) {
            server.on("modAbmProduct", ({ abmProducts }) => {
                dispatch({ type: ACTUALIZAR_PRODUCTOS_SOCKET, payload: abmProducts });
            });
            return () => server.off("modAbmProduct");
        }
    }, [server]);

    /*
        Función recuperar los productos y a su vez actualizarlos.
    */
    const actualizarProducts = async () => {

        try{

            const resp = await getAbmProduct();

            dispatch({
                type: ACTUALIZAR_PRODUCTOS,
                payload: resp.data.data
            })

            return resp.data.data;

        }catch(error){
            console.log(error);
        }
    }

    /*
        Función encargada de sobreescribir la base de datos de productos con la propia de Softland.
    */
    const actualizarProductsDB = async () => {

        try{
            console.log("ENTRO AL ACTUALIZAR PRODUCTOS");
            // El endpoint solo confirma que el proceso arrancó en segundo plano;
            // hay que esperar el aviso por socket para saber el resultado real.
            await uploadAbmProduct();

            if (!server) {
                throw new Error("No hay conexión en tiempo real disponible. Recargue la página e intente nuevamente.");
            }

            const resultado = await new Promise((resolve) => {
                server.once("actualizarAbmProductFinalizado", resolve);
            });

            if (resultado.status !== 200) {
                dispatch({
                    type: ERROR_PROD,
                    payload: resultado.message
                });
                return {status: false, msg: resultado.message};
            }

            const resp = await getAbmProduct();
            console.log(resp);
            dispatch({
                type: ACTUALIZAR_PRODUCTOS_DB,
                payload: resp.data.data
            });

        return {status: true, msg: "Se actualizo con exito la base de datos."};

        }catch(error){
            console.log(error);
            const errMsg = error?.response?.data?.errMsg || error.message;
            dispatch({
                type: ERROR_PROD,
                payload: errMsg
            });

            return {status: false, msg: errMsg};
        }
    }

    const cargando =  () => {
        dispatch({
            type: CARGANDO_PROD
        })
    }

    const limpiarError = () => {
        dispatch({
            type: LIMPIAR_ERROR
        })
    }

    return(
        <productsContext.Provider
            value={{
                products: state.products,
                isCargando: state.cargando,
                error: state.error,
                actualizarProducts,
                actualizarProductsDB,
                cargando,
                limpiarError
            }}
        >

            {props.children}

        </productsContext.Provider>
    )

}

export default ProductsState;
